// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/users.js';

import { paths } from '../generated/users';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('users', Original, paths);
